webpackJsonp([219805994829571],{

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/blanccambouis-web.744224fd.png";

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ccilyon-web.6348024f.png";

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/digital-signage.47aa2b7b.jpg";

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/emmaus-web.1cd36599.jpg";

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/handiscover-web.bde34a07.jpg";

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ipaje-web.69792020.jpg";

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scoreit-network.d1725977.png";

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _servicesModule = __webpack_require__(79);
	
	var _servicesModule2 = _interopRequireDefault(_servicesModule);
	
	var _blanccambouisWeb = __webpack_require__(97);
	
	var _blanccambouisWeb2 = _interopRequireDefault(_blanccambouisWeb);
	
	var _ccilyonWeb = __webpack_require__(98);
	
	var _ccilyonWeb2 = _interopRequireDefault(_ccilyonWeb);
	
	var _emmausWeb = __webpack_require__(99);
	
	var _emmausWeb2 = _interopRequireDefault(_emmausWeb);
	
	var _handiscoverWeb = __webpack_require__(100);
	
	var _handiscoverWeb2 = _interopRequireDefault(_handiscoverWeb);
	
	var _ipajeWeb = __webpack_require__(101);
	
	var _ipajeWeb2 = _interopRequireDefault(_ipajeWeb);
	
	var _digitalSignage = __webpack_require__(176);
	
	var _digitalSignage2 = _interopRequireDefault(_digitalSignage);
	
	var _scoreitNetwork = __webpack_require__(177);
	
	var _scoreitNetwork2 = _interopRequireDefault(_scoreitNetwork);
	
	var _ps = __webpack_require__(810);
	
	var _ps2 = _interopRequireDefault(_ps);
	
	var _labco = __webpack_require__(801);
	
	var _labco2 = _interopRequireDefault(_labco);
	
	var _ades = __webpack_require__(781);
	
	var _ades2 = _interopRequireDefault(_ades);
	
	var _integralShop = __webpack_require__(797);
	
	var _integralShop2 = _interopRequireDefault(_integralShop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Realisations = function (_Component) {
	    _inherits(Realisations, _Component);
	
	    function Realisations() {
	        _classCallCheck(this, Realisations);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Realisations.prototype.discover = function discover(data, title) {
	        if (data != "") {
	            return _react2.default.createElement(
	                "div",
	                { className: "col-md-12 p-0 d-flex justify-content-md-start justify-content-center" },
	                _react2.default.createElement(
	                    "a",
	                    { href: data, target: "_blank", title: 'En savoir plus sur  les ' + title, rel: "noopenerCannot read property 'frontmatter' of null", className: "btn btn-primary" },
	                    "D\xE9couvrir"
	                )
	            );
	        }
	    };
	
	    Realisations.prototype.render = function render() {
	        var _this2 = this;
	
	        var services = [{
	            title: 'Integral System',
	            subtitle: 'Un site E-Commerce B2B intégré et haute performance',
	            image: _integralShop2.default,
	            description: ["Développement à l'aide de Sylius d'un site E-Commerce haute performance pour Integral System spécialisé dans la fourniture de matériel informatique industriel comme les module ADAM, modules d'acquisition de données, affichages, écrans et pc industriels"],
	            url: 'https://www.integral-system.fr/shop/'
	        }, {
	            title: 'ADeS sécurité',
	            subtitle: 'Un site E-Commerce B2B intégré à Wavesoft',
	            image: _ades2.default,
	            description: ["Création d'un site E-Commerce haute performance pour la société ADeS Sécurité spécialisé dans le domaine de la sécurité, incendie, intrusion, vidéo surveillance, contrôle d’accès, communication hospitalière, sonorisation ou interphonie. Réalisé avec Sylius & Symfony."],
	            url: 'https://www.ades-securite.com/'
	        }, {
	            title: 'Synlab Labco',
	            subtitle: 'Portail et application mobile pour la gestion des analyses',
	            image: _labco2.default,
	            description: ["Réalisation d'un portail intranet et d'une application mobile dédiée à la gestion et au suivi des prélèvements des patients par les infirmières et les laboratoires d'analyse. Cette application centralise les prélèvements de plus de 5 millions de patients à travers l'Europe."],
	            url: ''
	        }, {
	            title: 'Michelin',
	            subtitle: 'E-Commerce éphémère',
	            image: _ps2.default,
	            description: ["Intégration du site de vente en ligne éphémère des pneus Michelin Pilot Sport 4. Réalisation d'une interface simple, graphique et intuitive pour améliorer la conversion et optimiser l'expérience de vente."],
	            url: ''
	        }, {
	            title: 'Myooh',
	            subtitle: 'Player et portail pour affichage dynamique',
	            image: _digitalSignage2.default,
	            description: ["Réalisation d'un portail Cloud et d'un player spécialisé pour l'affichage dynamique. Affichage entièrement Web, autonome et compatible offline spécialisé pour les métiers de l'immobilier."],
	            url: ''
	        }, {
	            title: 'Score It',
	            subtitle: 'Réseau social pour compositeurs de musique',
	            image: _scoreitNetwork2.default,
	            description: ["Réalisation d'un réseau social orienté grand public et professionnels pour les compositeurs de musique. Les utilisateurs peuvent partager sous forme multimédia l'ensemble de leurs actualités musicales."],
	            url: 'http://www.scoreit.org/'
	        }, {
	            title: 'Blanc Cambouis',
	            subtitle: 'Un site E-Commerce sur-mesure',
	            image: _blanccambouisWeb2.default,
	            description: ["Réalisation du ", _react2.default.createElement(
	                "a",
	                { href: "/e-commerce", title: "Site E-Commerce" },
	                "site E-Commerce"
	            ), " de la marque du designer de meuble vintage Blanc Cambouis. Vous pouvez entièrement choisir les options de votre meuble et les visualiser instantannément sur votre PC, Tablette ou Smartphone en 3D."],
	            url: 'https://www.blanccambouis.fr'
	        }, {
	            title: 'CCI Métropole Lyon',
	            subtitle: 'Portail Web métier',
	            image: _ccilyonWeb2.default,
	            description: ["Intégration de l'ensemble du ", _react2.default.createElement(
	                "a",
	                { href: "/portail-web-collaboratif", title: "R\xE9alisation de portail web" },
	                "portail Web m\xE9tier"
	            ), " de la CCI de Lyon métropole aux couleurs de la nouvelle charte graphique des CCI."],
	            url: 'https://www.lyon-metropole.cci.fr'
	        }, {
	            title: 'Emmaus International',
	            subtitle: 'Serious Game & Portail Web',
	            image: _emmausWeb2.default,
	            description: ["Le ", _react2.default.createElement(
	                "a",
	                { href: "/application-web", title: "Application web et serious game" },
	                "serious game"
	            ), " \"Dans les pas de l'abbé Pierre\" de l'association Emmaüs International vous propose à travers un parcours, de découvrir les différents combats de l'abbé Pierre. Votre choix d'un combat par thématique vous permettra de d'établir votre profil militant."],
	            url: 'http://www.actemmaus.org'
	        }, {
	            title: 'Handiscover',
	            subtitle: 'Application Web',
	            image: _handiscoverWeb2.default,
	            description: ["Le jeu Web Handiscover a été conçu afin de faire évoluer le regard sur le handicap de façon ludique et originale. A travers 3 niveaux, le joueur est amené à découvrir 12 innovations révolutionnant le quotidien des personnes en situation de handicap et ce, aux quatre coins du monde. Lorsqu’il découvre une innovation, il doit aussi répondre à 2 questions en lien avec le handicap abordé et cumuler un maximum de points."],
	            url: ''
	        }, {
	            title: 'Ipaje',
	            subtitle: 'Simulation de gestion d\'entreprise',
	            image: _ipajeWeb2.default,
	            description: ["Création, pour le compte de la société Ipaje, d'une ", _react2.default.createElement(
	                "a",
	                { href: "/application-web", title: "Une Application Web sous forme de serious Game" },
	                "application web responsive"
	            ), " de simulation de gestion d'entreprise qui simule la vie et les comptes d'entreprises, en compétition de marché, destinée à la formation pour les salariés ou les étudiants."],
	            url: ''
	        }];
	        var servicesHmtlList = _react2.default.createElement(
	            "div",
	            null,
	            services.map(function (service, index) {
	                return _react2.default.createElement(
	                    "section",
	                    { className: _servicesModule2.default.serviceSection },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "container" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row align-items-center" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-12" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "row row-bottom-padded-md row-top-padded-md " + _servicesModule2.default.serviceContent + " " + (index % 2 ? 'flex-row-reverse' : 'flex-row') },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "col-md-7 align-self-stretch d-flex text-center" },
	                                        _react2.default.createElement("img", { src: service.image, alt: service.title, className: "text-sm-center img-fluid align-self-center" })
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "col-md-5 align-self-stretch d-flex" },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "align-self-center" },
	                                            _react2.default.createElement(
	                                                "h2",
	                                                { className: "text-center text-md-left p-0 col-12 mb-2" },
	                                                service.title
	                                            ),
	                                            _react2.default.createElement(
	                                                "h3",
	                                                { className: "text-center text-md-left p-0 col-12" },
	                                                service.subtitle
	                                            ),
	                                            _react2.default.createElement(
	                                                "p",
	                                                { className: "text-justify" },
	                                                service.description
	                                            ),
	                                            _this2.discover(service.url, service.title)
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                );
	            })
	        );
	
	        return _react2.default.createElement(
	            "div",
	            { className: "serviceList" },
	            servicesHmtlList
	        );
	    };
	
	    return Realisations;
	}(_react.Component);
	
	exports.default = Realisations;
	module.exports = exports["default"];

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ades.9cc9325d.jpg";

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/integral-shop.8cb9687d.jpg";

/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/labco.a628887a.png";

/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ps4.6e4d4446.png";

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"projectimg":"src-components-Page----services-module---projectimg---2BSQf","serviceSection":"src-components-Page----services-module---serviceSection---2Q28l"};

/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/realisations.1d70baee.jpg";

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SocialLinks = __webpack_require__(16);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Realisation = __webpack_require__(293);
	
	var _Realisation2 = _interopRequireDefault(_Realisation);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _realisations = __webpack_require__(837);
	
	var _realisations2 = _interopRequireDefault(_realisations);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Contact = __webpack_require__(19);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	__webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RealisationApp = function (_Component) {
	    _inherits(RealisationApp, _Component);
	
	    function RealisationApp() {
	        _classCallCheck(this, RealisationApp);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    RealisationApp.prototype.render = function render() {
	        // SEO PURPOSES
	        var slug = this.props.pathContext.slug;
	
	
	        var postNode = {
	            "frontmatter": {
	                "title": "Quelques références",
	                "description": "Découvrez les dernières réalisation et références du Studio Web Integral Service.",
	                "cover": _realisations2.default
	            }
	        };
	
	        var title = "Nos réalisations";
	        var description = "Pour nos clients !";
	        var goto = "En découvrir plus";
	
	        return _react2.default.createElement(
	            "div",
	            { className: "webapp-container page-details" },
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(_Menu2.default, null),
	            _react2.default.createElement(_reactHelmet2.default, {
	                title: "Nos r\xE9alisations | " + _SiteConfig2.default.siteTitle,
	                description: "D\xE9couvrez les derni\xE8res r\xE9alisation et r\xE9f\xE9rences du Studio Web Integral Service."
	            }),
	            _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	            _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _realisations2.default }),
	            _react2.default.createElement(_Realisation2.default, null),
	            _react2.default.createElement(_SocialLinks2.default, { postPath: slug, postNode: postNode }),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return RealisationApp;
	}(_react.Component);
	
	exports.default = RealisationApp;
	
	;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-realisation-jsx-320ac50c82cee6717b05.js